module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"エンゲージ率"}}')
  delete Component.options._Ctor
}
